import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./inMaintenance.html";
import { MAINTENANCE_BANNER_ENDDATE } from '~/config';
import { WireI18n, i18nStore } from '~/modules/stores/i18nStore';
import { images } from '~/modules/utilities/assetUtilities';
class InMaintenancePage extends LightningElement {
  constructor(...args) {
    super(...args);
    this.appName = void 0;
    this.labels = void 0;
    this.sharedLabels = void 0;
    this.images = images;
  }
  i18nConnectedCallback(i18n) {
    this.labels = i18n.InMaintenance;
    this.sharedLabels = i18n.shared;
    this.appName = i18n.globalHeader.appName;
  }
  get maintenaceText() {
    return i18nStore.getState().i18n.InMaintenance.description({
      MANTEINANCE_END_DATE: MAINTENANCE_BANNER_ENDDATE
    });
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(InMaintenancePage, {
  wire: {
    i18nConnectedCallback: {
      adapter: WireI18n,
      method: 1,
      config: function ($cmp) {
        return {};
      }
    }
  },
  fields: ["appName", "labels", "sharedLabels", "images"]
});
const __lwc_component_class_internal = _registerComponent(InMaintenancePage, {
  tmpl: _tmpl,
  sel: "pages-in-maintenance",
  apiVersion: 62
});
export default __lwc_component_class_internal;